module.exports = "/assets/data/6182313da27f50057ebdd15e29630463-HU14.data.json";